import { render, staticRenderFns } from "./ModuleV2.vue?vue&type=template&id=76c5bda8&scoped=true&"
import script from "./ModuleV2.vue?vue&type=script&lang=js&"
export * from "./ModuleV2.vue?vue&type=script&lang=js&"
import style0 from "./ModuleV2.vue?vue&type=style&index=0&id=76c5bda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c5bda8",
  null
  
)

export default component.exports